/* This is the EMIS ethnic for primary school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table style="height: 72px" border="1px;" width="800" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 170px;
                height: 50px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              សិស្ស
            </td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ១</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ២</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៣</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៤</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៥</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៦</td>
            <td class="row-header" colspan="2">សរុប</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <!-- Except last row non teaching staff need minus 1 -->
          <tr
            v-for="(value, row) in c2.length - 2"
            v-if="row >= age_cont"
            :key="row"
          >
            <!-- This is data coloumn -->
            <td class="td-title">{{ c2[row] }}</td>
            <!-- Except non teaching column need minus 2 -->
            <td
              v-for="(value, col) in data[row].dt.length - 2"
              :key="col"
              :class="[!onOff[row][col] ? 'row-data-gray' : 'row-data']"
            >
              <numberinput
                v-model="data[row].dt[col]"
                :disabled="!onOff[row][col]"
                class="number"
              />
            </td>
            <!-- This is total column -->
            <td class="row-data">
              <strong>{{ row1[row] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ row2[row] | blank }}</strong>
            </td>
          </tr>
          <!--12 columns, Non teaching staff data row need only total_total and total_female -->
          <tr>
            <td class="td-title">{{ c2[4] }}</td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data-gray"></td>
            <td class="row-data">
              <numberinput v-model="data[4].dt[12]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[4].dt[13]" class="number" />
            </td>
          </tr>
          <!--This is the last row ចំនួនសិស្សរៀន​ ពហុភាសា-->
          <tr>
            <td class="td-title">{{ c2[5] }}</td>
            <!-- Except non teaching column need minus 2 -->
            <td
              v-for="(value, col) in data[5].dt.length - 2"
              :key="col"
              :class="[!onOff[5][col] ? 'row-data-gray' : 'row-data']"
            >
              <numberinput
                v-model="data[5].dt[col]"
                :disabled="!onOff[5][col]"
                class="number"
              />
            </td>
            <!-- This is total column -->
            <td class="row-data">
              <strong>{{ row1[5] | blank }}</strong>
            </td>
            <td class="row-data">
              <strong>{{ row2[5] | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { c2, ethpriOnOff } from "@/utils/ascf/priConfig.js";
export default {
  props: ["data", "age_cont", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      c2: c2,
      onOff: ethpriOnOff,
    };
  },
  computed: {
    // Compute function for re-entry program
    row1: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            if (i % 2 === 0) {
              r[ind] = (r[ind] || 0) + Number(b);
            }
          }
        });
        return r;
      }, []);
      return result;
    },
    row2: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            if (i % 2 === 1) {
              r[ind] = (r[ind] || 0) + Number(b);
            }
          }
        });
        return r;
      }, []);
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 45px;
  text-align: center;
}
.td-title {
  width: 170px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
.row-data {
  width: 45px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 45px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.row-header {
  width: 90px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>
